import * as ActionTypes from '../actions/actionTypes';
import {MODES} from '../Constants';

const initialState = {
  app_mode: MODES.UNSET,
  query_string_station_id: undefined
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_APP_MODE:
      return {
        ...state,
        app_mode: action.app_mode
      };

    case ActionTypes.SET_QS_STATION_ID:
      return {
        ...state,
        app_mode: MODES.WILDFIRE,
        query_string_station_id: action.station_id
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/app.js